import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-baseline" }
const _hoisted_2 = { class: "ml-4 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_c_icon, {
      name: "icon-gift",
      class: "w-15 h-15 -ml-1"
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.labels.lineItemWrappedAsGiftText), 1)
  ]))
}